import cn from 'classnames';
import { TypeAnimation } from 'react-type-animation';
import { Transition } from '@headlessui/react';

const ModelLoading = ({ step, setStep }) => (
  <div className="flex flex-col items-end space-y-2">
    <Transition
      show={step > 3 && step < 8}
      enter="transition-all ease duration-200 delay-1000"
      enterFrom="opacity-0 scale-50"
      enterTo="opacity-100 scale-100"
      leave="transition-all ease duration-150"
      leaveFrom="opacity-100"
      leaveTo="opacity-0 scale-50"
    >
      <div className="flex space-x-2">
        <TypeAnimation
          sequence={[
            '.',
            500,
            '..',
            500,
            '...',
            500,
            '..',
            500,
            '.',
            500,
            '..',
            500,
            '...',
            () => setStep(5)
          ]}
          wrapper="div"
          cursor={false}
          className={cn(
            'px-2.5 py-1 rounded-xl bg-neutral-900 border border-neutral-600 w-fit transition-opacity'
          )}
        />
        <img
          className="inline-block w-6 h-6 rounded-full ring-2 ring-neutral-600"
          src="/static/images/icons/llm-1.png"
          alt=""
        />
      </div>
    </Transition>
  </div>
);

export default ModelLoading;
